import React from "react";

const TaskListFilters = ({
    role = "admin",
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    viewFilter,
    setViewFilter,
    todayCount = 0,
    onAdvancedClick,
    onCompletedFilter,
}) => (
    <div className="flex flex-col gap-2">
        {role === "staff" && (
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => setViewFilter("today")}
                    className={`flex-1 rounded-lg border px-3 py-2.5 text-sm font-semibold transition min-h-[44px] ${
                        viewFilter === "today"
                            ? "border-primary bg-primary-soft text-primary"
                            : "border-line bg-surface-2 text-ink-secondary hover:bg-surface-3"
                    }`}
                >
                    Due today
                    {todayCount > 0 && (
                        <span className="ml-1.5 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded-full bg-primary text-primary-contrast text-[11px]">
                            {todayCount}
                        </span>
                    )}
                </button>
                <button
                    type="button"
                    onClick={() => setViewFilter("all")}
                    className={`flex-1 rounded-lg border px-3 py-2.5 text-sm font-semibold transition min-h-[44px] ${
                        viewFilter === "all"
                            ? "border-primary bg-primary-soft text-primary"
                            : "border-line bg-surface-2 text-ink-secondary hover:bg-surface-3"
                    }`}
                >
                    All tasks
                </button>
            </div>
        )}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
            <div className="flex flex-wrap gap-2">
                <select
                    value={statusFilter}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === "Completed") onCompletedFilter?.();
                        setStatusFilter(value);
                    }}
                    className="border border-line rounded-md px-2 py-2 text-xs bg-surface-2 text-ink focus:outline-none focus:ring-1 focus:ring-primary min-h-[44px] md:min-h-0 md:py-1"
                >
                    <option value="">All statuses</option>
                    <option value="active">Active</option>
                    <option value="Completed">Completed</option>
                </select>
                <select
                    value={priorityFilter}
                    onChange={(e) => setPriorityFilter(e.target.value)}
                    className="border border-line rounded-md px-2 py-2 text-xs bg-surface-2 text-ink focus:outline-none focus:ring-1 focus:ring-primary min-h-[44px] md:min-h-0 md:py-1"
                >
                    <option value="">All priorities</option>
                    <option value="high">High</option>
                    <option value="medium">Medium</option>
                    <option value="low">Low</option>
                </select>
            </div>
            <button
                type="button"
                onClick={onAdvancedClick}
                className="flex items-center gap-1 text-ink-secondary hover:text-ink cursor-pointer text-xs font-medium transition min-h-[44px] md:min-h-0"
            >
                Advanced options
            </button>
        </div>
    </div>
);

export default TaskListFilters;
